<template>
  <section
    v-if="discountedOffers?.length > 0"
    class="discounted-offers"
  >
    <Heading
      text-uppercase
      size="md"
      font-weight="ultra"
      align="center"
      tag="h2"
      spaces-bottom
    >
      Reduzierte Angebote
    </Heading>
    <GridContainer>
      <div>
        <OfferTiles
          class="discounted-offer__tiles"
          :offers="discountedOffers"
          :tag-title="tagTitle"
        />
      </div>
    </GridContainer>
  </section>
</template>

<script setup lang="ts">
import { useLazyAsyncData, defineComponent } from '#imports';

import { Heading, GridContainer } from '@i22-td-smarthome/component-library';
import OfferTiles from '~/components/offer-tiles-container.vue';
import fetchOffers from '@/lib/goliath/offers';
import { type ListQuery, OfferType } from '@/lib/goliath/goliath.types';

defineComponent({ name: 'DiscountedOffers' });

defineProps({
  tagTitle: { type: String, default: 'h2' },
});

const { data: discountedOffers, error: errorData } = useLazyAsyncData<
  NonNullable<ListQuery['offers']>['entries']
>('offers', () =>
  fetchOffers(
    {
      grouped: true,
      filter: {
        listed: true,
        types: ['TANGIBLE', 'MIXED'] as OfferType[],
        productAvailable: true,
        discounted: true,
      },
      pagination: {
        page: 1,
        size: 4,
      },
      includeAggregations: false,
    },
    false
  ).then((response) => response?.entries)
);
// handle errors
if (errorData.value) {
  console.error(errorData.value);
}
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.discounted-offers {
  margin-bottom: 3 * $grid-base;
}
</style>
